export enum StorageLocation {
  Both = "both",
  Disk = "disk",
  Memory = "memory",
}
